import { Navigate } from "react-router";
import type { ReactNode } from "react";
import { useAuth } from "./auth-context";
import { LoadingState } from "@/components/loading-state";

export function ProtectedRoute({ children, requirePermission }: { children: ReactNode; requirePermission?: string }) {
  const { me, loading, permissions } = useAuth();
  if (loading) return <LoadingState />;
  if (!me) return <Navigate to="/login" replace />;
  if (requirePermission && !permissions.has(requirePermission))
    return <Navigate to="/" replace />;
  return <>{children}</>;
}
